import { IndicatorColorRange } from "constants/indicatorConstants";
import dayjs from "configs/dayjs.config";

export const getAlertColor = (lotDeadline, estimatedEndDate, taskToOn) => {
  let flag = 0;
  if (taskToOn) {
    flag = dayjs(taskToOn).diff(dayjs(estimatedEndDate), "days") > 0 ? 0 : 1;
  } else {
    flag = dayjs(lotDeadline).isBefore(dayjs());
  }
  return flag ? IndicatorColorRange.veryHigh : "";
};

export const getAlertColorFromCriticalFlag = (flag) => {
  return flag ? IndicatorColorRange.veryHigh : "";
};
